import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input, Selection } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { EnumChannel } from 'enums';

import { Typeof } from 'utils';
import { API } from 'services';

class ModalEditDevice extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  handleSubmit(data, onSucess, onError) {

    let channels = data.channels.trim();

    if (Typeof.string(channels)) {

      if (channels.length > 0) {
        data.channels = channels.split(',');
      } else {
        delete data.channels;
      }
    }

    API.put(`/devices/${this.props.device.id}`, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    const { device } = this.props;

    let channels = EnumChannel.values.map((channel) => {
      return {
        key: channel,
        value: channel,
        text: EnumChannel.name(channel)
      }
    });

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size="small">
          <Header icon="edit" content="Modification valise" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Delivery date */}
              <Form.Field>
                <label htmlFor="inputDeliveryDate">Date de livraison</label>
                <Input type="date" id="inputDeliveryDate" name="delivery_date" value={device.delivery_date} />
              </Form.Field>

              {/* Distribution channels */}
              <Form.Field>
                <label htmlFor="inputChannels">Canaux de distribution de micrologiciel</label>
                <Selection multiple options={channels} name="channels" value={device.channels} noResultsMessage="Aucun canal disponible" />
              </Form.Field>

              {/* Subscription deadline */}
              <Form.Field>
                <label htmlFor="inptuSubscriptionDeadline">Date limite d'abonnement</label>
                <Input type="date" id="inptuSubscriptionDeadline" name="subscription_deadline" value={device.subscription_deadline} />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalEditDevice.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalEditDevice;
